import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserFriends, FaTicketAlt, FaChartBar } from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

export default function Administracion() {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — Administración"
      subtitle="Consulta en modo solo lectura los reportes de invitaciones y entradas."
      roleLabel="Rol: Administración"
    >
      <RoleGrid><RoleTile label="Administración de consumo" onClick={()=>navigate('/admin/consumo')}/>
        {/* ✅ NUEVO: Panel de reservas (lectura/exportación) */}
        <RoleTile
          icon={FaChartBar}
          label="Panel de Reservas"
          description="Consulta y exporta reservas por evento."
          onClick={() => navigate('/admin/reservas-panel')}
        />

        <RoleTile
          icon={FaUserFriends}
          label="Invitaciones"
          description="Revisa y exporta el detalle de las invitaciones generadas."
          onClick={() => navigate('/admin/invitaciones')}
        />
        <RoleTile
          icon={FaTicketAlt}
          label="Entradas"
          description="Visualiza y exporta el estado de las entradas."
          onClick={() => navigate('/entradas/admin')}
        />
      </RoleGrid>
    </RoleLayout>
  );
}
